import { Suspense, lazy } from 'react';
import LoadingPaper from '@atoms/LoadingPaper';
import type { EventInfo, InlineEditor } from 'ckeditor5';
import './text-editor.css';
const CKEditor = lazy(() => import('@atoms/CKEditor'));

interface Props {
    data?: string | null | undefined;
    onChange?: ((event: EventInfo, editor: InlineEditor) => void) | undefined;
}

// Wrapper for CKEditor that uses Suspense to lazy load the CKEditor component (bundle splitting)
export default function RichTextEditor(props: Props) {
    return (
        <Suspense fallback={<LoadingPaper loading />}>
            <CKEditor {...props} />
        </Suspense>
    );
}
